<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<p class="CN" id="_idParaDest-1"><img alt="" class="_idGenObjectAttribute-1" src="image/HueTitle.jpg"/> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V4557.vue?548176ac